module.exports = "M3,12H6V19H9V12H12V9H3M9,4V7H14V19H17V7H22V4H9Z"


//////////////////
// WEBPACK FOOTER
// ./node_modules/material-design-icons-svg/paths/format-size.json
// module id = 420
// module chunks = 0